import React, {Fragment} from "react";

import {NavigationDesktop} from "./NavigationDesktop";
import {INavLink, NavigationMobile} from "./NavigationMobile";

interface IOwnProps {
    refElems: {
        refAboutIssue: React.RefObject<HTMLTableSectionElement | null>;
        refLatestEdition: React.RefObject<HTMLTableSectionElement | null>;
        refArchive: React.RefObject<HTMLTableSectionElement | null>;
        refContact: React.RefObject<HTMLTableSectionElement | null>;
    };
    scrollTo: (duration: number, refElem: React.RefObject<HTMLTableSectionElement | null>) => (e: React.MouseEvent) => void;
}

export const Navigation = (props: IOwnProps) => {
    const {refElems, scrollTo} = props;

    const links: INavLink[] = [
        {
            text: "O Kwartalniku",
            url: refElems.refAboutIssue
        },
        {
            text: "Najnowszy numer",
            url: refElems.refLatestEdition
        },
        {
            text: "Archiwum",
            url: refElems.refArchive
        },
        {
            text: "Kontakt",
            url: refElems.refContact
        }
    ];

    return (
        <Fragment>
            <NavigationDesktop links={links} scrollTo={scrollTo} />

            <NavigationMobile links={links} scrollTo={scrollTo} />
        </Fragment>
    );
};
import React, {Fragment} from "react";

import {NavigationDesktop} from "./NavigationDesktop";
import {INavLink, NavigationMobile} from "./NavigationMobile";

interface IOwnProps {
    refElems: {
        refAboutIssue: React.RefObject<HTMLTableSectionElement | null>;
        refLatestEdition: React.RefObject<HTMLTableSectionElement | null>;
        refArchive: React.RefObject<HTMLTableSectionElement | null>;
        refContact: React.RefObject<HTMLTableSectionElement | null>;
    };
    scrollTo: (duration: number, refElem: React.RefObject<HTMLTableSectionElement | null>) => (e: React.MouseEvent) => void;
}

export const Navigation = (props: IOwnProps) => {
    const {refElems, scrollTo} = props;

    const links: INavLink[] = [
        {
            text: "O Kwartalniku",
            url: refElems.refAboutIssue
        },
        {
            text: "Najnowszy numer",
            url: refElems.refLatestEdition
        },
        {
            text: "Archiwum",
            url: refElems.refArchive
        },
        {
            text: "Kontakt",
            url: refElems.refContact
        }
    ];

    return (
        <Fragment>
            <NavigationDesktop links={links} scrollTo={scrollTo} />

            <NavigationMobile links={links} scrollTo={scrollTo} />
        </Fragment>
    );
};
